import React, { useState } from 'react';
import { Send, CheckCircle, Phone, MapPin } from 'lucide-react';
type FormState = {
  name: string;
  phone: string;
  email: string;
  service: string;
  message: string;
};
const serviceOptions = ['Monthly Pool Service', 'Pool Repairs', 'Tile Cleans', 'Acid & Chlorine Wash', 'Hardscape', 'Grill Cleaning', 'Water Features', 'Other / Not Sure'];
export function Contact() {
  const [form, setForm] = useState<FormState>({
    name: '',
    phone: '',
    email: '',
    service: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setForm(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setSubmitted(true);
    }, 1200);
  };
  return <section id="contact" className="w-full bg-[#0a0e16] pt-12 pb-20 sm:py-20 px-4 sm:px-6" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        {/* Header */}
        <div className="text-center mb-12" data-id="element-3">
          <span className="text-[#2979ff] text-sm font-bold tracking-widest uppercase" data-id="element-4">
            Get in Touch
          </span>
          <h2 className="text-3xl sm:text-5xl font-black text-white mt-2 mb-4" data-id="element-5">
            Ready for an Elite Backyard?
          </h2>
          <p className="text-gray-400 max-w-xl mx-auto text-base sm:text-lg" data-id="element-6">
            Fill out the form and we'll get back to you with a free quote. No
            pressure, no commitment.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-7">
          {/* Contact info */}
          <div className="flex flex-col gap-6 text-center lg:text-left" data-id="element-8">
            <div className="bg-[#141b27] border border-[#1e2a3a] rounded-2xl p-6" data-id="element-9">
              <div className="text-[#2979ff] mb-3 flex justify-center lg:justify-start" data-id="element-10">
                <Phone size={24} data-id="element-11" />
              </div>
              <h3 className="text-white font-bold text-lg mb-1" data-id="element-12">
                Call or Text
              </h3>
              <a href="tel:+1" className="text-[#2979ff] hover:underline font-semibold" data-id="element-13">
                Contact us for number
              </a>
              <p className="text-gray-400 text-sm mt-2" data-id="element-14">
                Available Mon–Sat, 7am–6pm
              </p>
            </div>

            <div className="bg-[#141b27] border border-[#1e2a3a] rounded-2xl p-6" data-id="element-15">
              <div className="text-[#2979ff] mb-3 flex justify-center lg:justify-start" data-id="element-16">
                <MapPin size={24} data-id="element-17" />
              </div>
              <h3 className="text-white font-bold text-lg mb-1" data-id="element-18">
                Service Area
              </h3>
              <p className="text-gray-300 font-semibold" data-id="element-19">Arizona 📍</p>
              <p className="text-gray-400 text-sm mt-2" data-id="element-20">
                Serving the greater Phoenix metro and surrounding AZ
                communities.
              </p>
            </div>

            <div className="bg-[#2979ff] rounded-2xl p-6" data-id="element-21">
              <p className="text-white font-bold text-lg mb-2" data-id="element-22">
                Follow Our Work
              </p>
              <p className="text-blue-100 text-sm" data-id="element-23">
                Check out our latest jobs and updates on social media.
              </p>
              <p className="text-white font-bold mt-3" data-id="element-24">@ElitePoolz</p>
            </div>
          </div>

          {/* Form */}
          <div className="lg:col-span-2" data-id="element-25">
            {submitted ? <div className="bg-[#141b27] border border-[#2979ff] rounded-2xl p-10 flex flex-col items-center justify-center text-center h-full min-h-[400px]" data-id="element-26">
                <CheckCircle size={56} className="text-[#2979ff] mb-4" data-id="element-27" />
                <h3 className="text-white font-black text-2xl mb-2" data-id="element-28">
                  Request Sent!
                </h3>
                <p className="text-gray-400 text-base max-w-sm" data-id="element-29">
                  Thanks, {form.name || 'friend'}! We'll be in touch shortly
                  with your free quote.
                </p>
                <button onClick={() => {
              setSubmitted(false);
              setForm({
                name: '',
                phone: '',
                email: '',
                service: '',
                message: ''
              });
            }} className="mt-6 text-[#2979ff] hover:underline text-sm font-medium" data-id="element-30">
                  Submit another request
                </button>
              </div> : <form onSubmit={handleSubmit} className="bg-[#141b27] border border-[#1e2a3a] rounded-2xl p-5 sm:p-8 flex flex-col gap-5 text-left" noValidate data-id="element-31">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5" data-id="element-32">
                  <div className="flex flex-col gap-1.5" data-id="element-33">
                    <label htmlFor="name" className="text-gray-300 text-sm font-semibold" data-id="element-34">
                      Full Name <span className="text-[#2979ff]" data-id="element-35">*</span>
                    </label>
                    <input id="name" name="name" type="text" required value={form.name} onChange={handleChange} placeholder="Jane Smith" className="w-full bg-[#0d1117] border border-[#1e2a3a] focus:border-[#2979ff] focus:ring-2 focus:ring-[#2979ff]/30 rounded-lg px-4 py-3 text-base sm:text-sm text-white placeholder-gray-600 outline-none transition-colors" data-id="element-36" />
                  </div>
                  <div className="flex flex-col gap-1.5" data-id="element-37">
                    <label htmlFor="phone" className="text-gray-300 text-sm font-semibold" data-id="element-38">
                      Phone Number <span className="text-[#2979ff]" data-id="element-39">*</span>
                    </label>
                    <input id="phone" name="phone" type="tel" required value={form.phone} onChange={handleChange} placeholder="(480) 555-0100" className="w-full bg-[#0d1117] border border-[#1e2a3a] focus:border-[#2979ff] focus:ring-2 focus:ring-[#2979ff]/30 rounded-lg px-4 py-3 text-base sm:text-sm text-white placeholder-gray-600 outline-none transition-colors" data-id="element-40" />
                  </div>
                </div>

                <div className="flex flex-col gap-1.5" data-id="element-41">
                  <label htmlFor="email" className="text-gray-300 text-sm font-semibold" data-id="element-42">
                    Email Address
                  </label>
                  <input id="email" name="email" type="email" value={form.email} onChange={handleChange} placeholder="jane@example.com" className="w-full bg-[#0d1117] border border-[#1e2a3a] focus:border-[#2979ff] focus:ring-2 focus:ring-[#2979ff]/30 rounded-lg px-4 py-3 text-base sm:text-sm text-white placeholder-gray-600 outline-none transition-colors" data-id="element-43" />
                </div>

                <div className="flex flex-col gap-1.5" data-id="element-44">
                  <label htmlFor="service" className="text-gray-300 text-sm font-semibold" data-id="element-45">
                    Service Needed <span className="text-[#2979ff]" data-id="element-46">*</span>
                  </label>
                  <select id="service" name="service" required value={form.service} onChange={handleChange} className="w-full bg-[#0d1117] border border-[#1e2a3a] focus:border-[#2979ff] focus:ring-2 focus:ring-[#2979ff]/30 rounded-lg px-4 py-3 text-base sm:text-sm text-white outline-none transition-colors" data-id="element-47">
                    <option value="" disabled data-id="element-48">
                      Select a service…
                    </option>
                    {serviceOptions.map(s => <option key={s} value={s} data-id="element-49">
                        {s}
                      </option>)}
                  </select>
                </div>

                <div className="flex flex-col gap-1.5" data-id="element-50">
                  <label htmlFor="message" className="text-gray-300 text-sm font-semibold" data-id="element-51">
                    Tell Us More
                  </label>
                  <textarea id="message" name="message" rows={4} value={form.message} onChange={handleChange} placeholder="Describe your pool, any issues, or questions…" className="w-full bg-[#0d1117] border border-[#1e2a3a] focus:border-[#2979ff] focus:ring-2 focus:ring-[#2979ff]/30 rounded-lg px-4 py-3 text-base sm:text-sm text-white placeholder-gray-600 outline-none transition-colors resize-none" data-id="element-52" />
                </div>

                <button type="submit" disabled={loading} className="flex items-center justify-center gap-2 bg-[#2979ff] hover:bg-[#1a5fd4] disabled:opacity-60 text-white font-bold py-4 rounded-xl text-base transition-colors shadow-lg shadow-[#2979ff]/20" data-id="element-53">
                  {loading ? <span className="animate-pulse" data-id="element-54">Sending…</span> : <>
                      <Send size={16} data-id="element-55" />
                      Send My Request
                    </>}
                </button>
              </form>}
          </div>
        </div>
      </div>
    </section>;
}